import { memo } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Link from '~/components/router/query-encoded-link.js';
import { Caption } from '@comeon/ui';

const TabBarContainer = memo(styled.nav`
	background-color: var(--product-tab, rgba(var(--base-10), 1));
	display: flex;
	border-top: 1px solid var(--product-tab-border-top, rgba(var(--base-09), 1));
	justify-content: center;
`);

const TabUlList = memo(styled.ul`
	display: flex;
`);

const TabListItem = memo(styled.li`
	> span > a[aria-selected] {
		cursor: pointer;
	}
	a[aria-selected='true'] {
		flex-grow: 1;
		text-align: center;
	}
`);

const TabLinkEffect = styled(motion.span)`
	display: block;
	svg {
		fill: var(--product-tab-content, rgba(var(--base-02), 1));
		margin: 0 auto 0 auto;
	}
`;

const ProductCaption = styled(Caption)`
	color: var(--product-tab-content, rgba(var(--base-02), 1));
`;

const WHILE_TAP_SCALE = { scale: 0.9 };

const TabItem = props => {
	const { Icon, label, href, ...rest } = props;
	return (
		<TabListItem className="tab u-text-c u-cursor-hand">
			<TabLinkEffect whileTap={WHILE_TAP_SCALE}>
				<Link href={href} {...rest}>
					{Icon}
					<ProductCaption as="span">{label}</ProductCaption>
				</Link>
			</TabLinkEffect>
		</TabListItem>
	);
};

const TabBar = ({ children, dataAt, ...rest }) => (
	<TabBarContainer {...rest}>
		<TabUlList data-at={dataAt}>{children}</TabUlList>
	</TabBarContainer>
);

export { TabBar, TabItem };
